import { combineReducers } from '@reduxjs/toolkit';

import globalElementsReducer from 'redux/global-elements-slice';
import pendingTimesheetsReducer from 'features/pending-timesheets/redux/pending-timesheets-slice';
import selectedTimesheetReducer from 'features/pending-timesheets/redux/selected-timesheet-slice';
import selectedTimesheetTimeEntriesReducer from 'features/pending-timesheets/redux/time-entries-slice';
import messageModalReducer from 'redux/message-modal-slice';

const rootReducer = combineReducers({
    globalElements: globalElementsReducer,
    pendingTimesheets: pendingTimesheetsReducer,
    selectedTimesheet: selectedTimesheetReducer,
    timeEntries: selectedTimesheetTimeEntriesReducer,
    messageModal: messageModalReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
